<template>
    <b-tabs card>
      <b-tab title="Saved searches and alerts">
        <b-card class="mb-5">
          <b-container >
            <b-row class="my-1">
              <b-col sm="3">
                <label for="savedSearchName"><strong>Name</strong></label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="savedSearchName" type="text" v-model="searchToSave.name" :state="nameRequired"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="3">
                <label for="savedSearchDescription"><strong>Description</strong></label>
              </b-col>
              <b-col sm="9">
                <b-form-input id="savedSearchDescription" type="text" v-model="searchToSave.description"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="3">
                <label for="savedSearchAlert"><strong>Alert</strong></label>
              </b-col>
              <b-col sm="9">
                <b-form-select id="savedSearchAlert" v-model="searchToSave.frequency" :options="options"></b-form-select>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-button size="md" class="mr-1" v-on:click.prevent="clearSearch" variant="info">Clear</b-button>
                <b-button size="md" class="mr-1" v-on:click.prevent="saveSearch">Save</b-button>
              </b-col>
            </b-row>
          </b-container>

        </b-card>

        <b-table v-if="savedSearches != ''" responsive :items="savedSearches" :fields="fields">
          <template #cell(show_details)="row">
            <div class="text-nowrap">
                <b-button size="sm" class="mr-1" v-on:click="performSearch(row.item)" variant="secondary"><b-icon icon="search" font-scale="1.3" variant="white"></b-icon></b-button>
                <b-button size="sm" class="mr-1" v-on:click.prevent="selectSearch(row.item)">Select</b-button>
                <b-button size="sm" variant="danger" v-on:click.prevent="deleteSearch(row.item)">Delete</b-button>
              </div>
            </template>
        </b-table>
      </b-tab>

    </b-tabs>
</template>

<script>
import moment from 'moment';
export default {
  name: 'SavedSearches',
  data() {
    return {
      searchToSave: {
        "name": "",
        "query": "",
        "description": "",
        "frequency": "NONE"
      },
      options: ['NONE', 'DAILY', 'WEEKLY', 'MONTHLY'],
      fields: [
          {
            key: 'show_details',
            label: '',
            sortable: false
          },
          {
            key: 'name',
            label: 'Title',
            sortable: true
          },
          {
            key: 'description',
            label: 'Description',
            sortable: true
          },
          {
            key: 'frequency',
            label: 'Alert frequency',
            sortable: true
          },
          {
            key: 'updated',
            label: 'Last updated',
            sortable: true,
            formatter: value => {
              return moment(value).format("DD. MMM YYYY hh:mm")
            }
          },
        ],
    }
  },
  created: function () {
    //if( this.savedSearches == null || this.savedSearches == '' ) {
      this.$store.dispatch('fetchSavedSearches');
    //}
  },
  computed: {
    savedSearches () {
      return this.$store.state.savedSearches;
    },
    nameRequired() {
      return this.searchToSave.name.length > 0 ? true : false
    }
  },
  methods: {
    saveSearch() {
      this.$store.dispatch('saveSearch', { 'searchToSave': this.searchToSave });
      this.clearSearch();
    },
    clearSearch () {
      this.searchToSave = {
        "id": "",
        "name": "",
        "query": "",
        "description": "",
        "frequency": "NONE"
      };
    },
    selectSearch(search) {
      this.searchToSave.id = search.id;
      this.searchToSave.name = search.name;
      this.searchToSave.query = search.query;
      this.searchToSave.description = search.description;
      this.searchToSave.frequency = search.frequency;
    },
    deleteSearch(search) {
      this.$store.dispatch('deleteSearch', { 'searchToDelete': search });
    },
    performSearch(search) {
      this.$router.push('/' + search.query);
    }
  }

}
</script>
<style scoped>
</style>
